import moment from "moment/moment";
import {resetDateTime} from "../../../helpers";

export const useDashboardCaseBlockHeaderColor = (
    calendarDate,
    dateAfter10Days,
    countOfUnitsMisc,
    countOfUnitsZyrc,
    statusOfDay,
    vacationDays,
    eightBusinessDaysFromCurrentDate = [],
) => {
    let className = 'success';
    if (countOfUnitsMisc <= 5 || countOfUnitsZyrc <= 5) {
        className = 'warning';
    }
    if (moment(calendarDate).isSameOrBefore(moment().toDate()) || countOfUnitsMisc <= 0 && countOfUnitsZyrc <= 0) {
        className = 'danger';
    }

    if (eightBusinessDaysFromCurrentDate.includes(moment(calendarDate).format("YYYY-MM-DD"))) {
        className = "danger"
    }

    if(vacationDays.length){
        const dateWithoutTime = resetDateTime(calendarDate);
        vacationDays.some((item)=>{
            if(resetDateTime(new Date(item.start)) <= dateWithoutTime && dateWithoutTime <= resetDateTime(new Date(item.end))){
                className = 'vacation';
                return true;
            }
        })
    }
    if (moment(calendarDate).day() === 0 || moment(calendarDate).day() === 6) {
        className = 'danger';
    }
    if (statusOfDay === 'pending') {
        className = 'blockedItem';
    }
    return className
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/CustomHooks/useDashboardCaseBlockHeaderColor.js